import { createSpin, KEY } from './spin/createSpin';

const attributes = [
  { key: 'spin-text', prop: 'description' },
  { key: 'spin-bg', prop: 'background' },
  { key: 'spin-index', prop: 'zIndex' }
];

/**
 * 获取尺寸
 * @param modifiers 指令修饰符
 */
const getSize = modifiers => {
  const { small, large } = modifiers;
  if (small && large) return '';
  if (small) return 'small';
  if (large) return 'large';
  return '';
};

/**
 * 获取属性
 * @param el 当前dom节点
 */
const getAttrs = el => {
  const props = {};
  attributes.forEach(attr => {
    props[attr.prop] = el.attributes[attr.key]?.value;
  });
  return props;
};

/**
 * 在当前dom节点上创建加载实例
 * @param el
 */
const createInstance = (el, binding) => {
  const { modifiers } = binding;
  const size = getSize(modifiers);
  const props = getAttrs(el);
  props.size = size;
  el[KEY] = createSpin(el, props);
};

/**
 * v-spin 自定义加载指令
 * 支持传入修饰符(small, large)改变尺寸
 * 支持给dom属性赋值来改变实例属性
 * @prop spin-text 描述文字
 * @prop spin-bg 背景色
 * @prop spin-index 层级
 * @author qinzz
 */
export const vSpin = {
  inserted(el, binding) {
    if (binding.value) {
      createInstance(el, binding);
    }
  },
  update(el, binding) {
    const instance = el[KEY];
    if (binding.oldValue !== binding.value) {
      if (binding.value && !binding.oldValue) {
        // 已存在实例，先销毁
        if (instance) instance.destroy();
        createInstance(el, binding);
      } else {
        instance.hide();
      }
    }
  }
};

export default vSpin;
